import { defineComponent as _defineComponent } from 'vue'
import Avatar from '../../../common/Avatar.vue';
import ApplyStageLabelIcon from '../../../common/icons/ApplyStageLabelIcon.vue';
import useMasterApplyControl from '../../../../hooks/useMasterApplyControl';
import SvgIcon from '../../../common/base/SvgIcon.vue';
import { roomService } from '../../../../services';


export default /*#__PURE__*/_defineComponent({
  __name: 'MasterApplyControlH5',
  setup(__props) {

const {
  t,
  applyToAnchorList,
  handleAllUserApply,
  handleUserApply,
  applyToAnchorUserCount,
} = useMasterApplyControl();

return { __sfc: true,t, applyToAnchorList, handleAllUserApply, handleUserApply, applyToAnchorUserCount, Avatar, ApplyStageLabelIcon, SvgIcon, roomService }
}

})